import React from 'react'
import parse from 'html-react-parser'
import {useContentAsset} from '../../hooks/use-content-asset'
import {Box} from '@salesforce/retail-react-app/app/components/shared/ui'

/**
 * Default Contet Asset to render the data fetched from Business Manager
 * @param props - The props will return the following data fetched from the footer.jsx
 *  id - Content Asset Id
 */

const ContentAsset = (props) => {
    const params = props
    const contentAsset = useContentAsset(params)

    return <Box className="content-asset">{contentAsset && parse(contentAsset)}</Box>
}

export default ContentAsset
